import { languages } from '../../consts';
import { LanguageCode } from '../../graphql/globalTypes';

export const getRTL = (language: LanguageCode): boolean => {
  return Boolean(languages[language]?.rtl);
};
